import {
  COMMON_FUNCTION_NAME,
  createFunctionResult,
  FUNCTION_ERROR_MESSAGES,
  FUNCTION_RESULT_STATUS,
  FunctionResult,
  ICommonSearch,
  ICommonSearchKey,
  ICommonSearchStatement,
  IObjectKey,
  isObjectKey,
} from "@nova/common-interfaces";
import { BehaviorSubject, Observable } from "rxjs";
import { Functions, httpsCallable } from "@angular/fire/functions";
import { Injectable } from "@angular/core";
import { getAuth } from "@angular/fire/auth";

@Injectable({ providedIn: "root" })
export abstract class CommonPagedReadOnlyService<T, K> {
  // #region Properties (7)

  private _isLoading = new BehaviorSubject<boolean>(false);
  private _myObjects = new BehaviorSubject<T[]>([]);

  public abstract getAllFunctionName: COMMON_FUNCTION_NAME;
  public abstract getFunctionName: COMMON_FUNCTION_NAME;
  public abstract getKeysFunctionName: COMMON_FUNCTION_NAME;
  isLoading$: Observable<boolean> = this._isLoading.asObservable();
  objects$: Observable<T[]> = this._myObjects.asObservable();

  // #endregion Properties (7)

  // #region Constructors (1)

  constructor(protected functions: Functions) {}

  // #endregion Constructors (1)

  // #region Public Methods (5)

  public async get(key: IObjectKey | string): Promise<FunctionResult<T>> {
    this._isLoading.next(true);

    let myId = "";
    if (isObjectKey(key)) {
      console.log("service-get isObjectKey", key);
      myId = (key as IObjectKey).id;
    } else {
      myId = key as string;
    }

    return new Promise<FunctionResult<T>>((resolve, reject) => {
      const callable = httpsCallable<IObjectKey | string, FunctionResult<T>>(
        this.functions,
        this.getFunctionName.toString()
      );
      callable({ id: myId })
        .then(
          (result) => {
            console.debug("Result", result.data);
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(createFunctionResult<T | null>(FUNCTION_RESULT_STATUS.ERROR, null));
          }
        )
        .finally(() => {
          this._isLoading.next(false);
        });
    });
  }

  public async getAll(filter? : ICommonSearch): Promise<FunctionResult<T[]>> {
    this._isLoading.next(true);
    const a = getAuth();

    return new Promise<FunctionResult<T[]>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<T[]>>(
        this.functions,
        this.getAllFunctionName.toString()
      );
      callable({ payload : filter })
        .then(
          (result) => {
            if (result.data.status == FUNCTION_RESULT_STATUS.SUCCESS) {
              this.setObjects(result.data.data!);
            }
            resolve(result.data);
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this._isLoading.next(false);
        });
    });
  }

  public async getKeys(filter? : ICommonSearchKey | ICommonSearchKey[] | ICommonSearchStatement): Promise<FunctionResult<K[]>> {
    this._isLoading.next(true);
    const a = getAuth();

    return new Promise<FunctionResult<K[]>>((resolve, reject) => {
      const callable = httpsCallable<any, FunctionResult<K[]>>(
        this.functions,
        this.getKeysFunctionName.toString()
      );
      callable({payload: filter})
        .then(
          (result) => {
            if (result.data.status == FUNCTION_RESULT_STATUS.SUCCESS) {
              resolve(result.data);
            } else {
              reject(FUNCTION_ERROR_MESSAGES.QUERY_FAILED);
            }
          },
          (error) => {
            console.error(error);
            reject(error);
          }
        )
        .finally(() => {
          this._isLoading.next(false);
        });
    });
  }

  public isLoading(state: boolean) {
    this._isLoading.next(state);
  }

  public setObjects(value: T[]) {
    this._myObjects.next(value);
  }

  // #endregion Public Methods (5)
}
